import React, { useMemo } from 'react';
// import { DateRangePicker as DRP, DateRange } from 'mui-daterange-picker';
import { DateRange as DRP } from 'react-date-range';

import { ClickAwayListener, IconButton, InputAdornment, Stack, TextField } from '@mui/material';
import { format } from 'date-fns';
import { CalendarFilled } from '@ant-design/icons';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import styled from '@emotion/styled';
import { Box } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';

import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

import { useTheme } from '@mui/material/styles';

const DatePickerWrapper = styled.div`
  position: absolute;
  right: 0;
  z-index: 999;
  .MuiList-padding {
    display: none;
  }

  .MuiGrid-wrap-xs-nowrap {
    // & > :nth-child(1) {
    //   display: none;
    // }
    flex-wrap: wrap;
  }
`;

const initialValue = {
  startDate: null,
  endDate: null
};
const DateRangePicker = React.forwardRef(({ value, onChange, onBlur, name, id, ...rest }, ref) => {
  const [open, setOpen] = React.useState(false);
  const [dateRange, setDateRange] = React.useState(value || initialValue);
  const sanitisedValue = useMemo(() => {
    const { startDate, endDate } = dateRange;

    const formatStart = startDate ? format(startDate, 'dd/MM/yyyy') : null;
    const formatEnd = endDate ? format(endDate, 'dd/MM/yyyy') : null;

    if (!formatStart && !formatEnd) {
      return '';
    }

    return `${formatStart} - ${formatEnd}`;
  }, [dateRange]);

  const toggle = () => {
    setOpen((prev) => !prev);
  };

  const theme = useTheme();
  const OutlinedInputBorderRadius = '12px';

  return (
    <Box position="relative">
      <TextField
        name={name}
        value={sanitisedValue}
        fullWidth
        ref={ref}
        disabled
        sx={{
          '> div': {
            paddingRight: '2px'
          },
          '& .MuiInputBase-input': {
            opacity: 1
          },
          '& .Mui-disabled': {
            WebkitTextFillColor: 'black'
          },
          '& .MuiInputBase-root': {
            borderRadius: OutlinedInputBorderRadius
          }
        }}
        // placeholder="dd/mm/yyyy - dd/mm/yyyy"
        InputProps={
          rest.disabled
            ? {}
            : {
                endAdornment: (
                  <InputAdornment position="end" sx={{ ml: 0 }}>
                    <Stack direction="row">
                      {!!dateRange.startDate && (
                        <IconButton
                          onClick={(e) => {
                            setDateRange(initialValue);
                            onChange(initialValue);
                            e.stopPropagation();
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      )}
                      <IconButton onClick={toggle}>
                        <CalendarMonthOutlinedIcon sx={{ color: theme.palette.primary[400] }} />
                      </IconButton>
                    </Stack>
                  </InputAdornment>
                )
              }
        }
      />
      {open && (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <DatePickerWrapper>
            <DRP
              toggle={toggle}
              ranges={[
                {
                  startDate: dateRange.startDate ?? new Date(),
                  endDate: dateRange.endDate ?? new Date(),
                  key: 'selection'
                }
              ]}
              rangeColors={['#4fb794']}
              onChange={(range) => {
                setDateRange(range.selection);
                onChange(range.selection);

                // onBlur(range);
              }}
              on
              scroll={{ enabled: true }}
            />
          </DatePickerWrapper>
        </ClickAwayListener>
      )}
    </Box>
  );
});

export default DateRangePicker;
